import { render } from "./EmailComponent.vue?vue&type=template&id=3673f1fd&scoped=true"
import script from "./EmailComponent.vue?vue&type=script&lang=js"
export * from "./EmailComponent.vue?vue&type=script&lang=js"

import "./EmailComponent.vue?vue&type=style&index=0&id=3673f1fd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3673f1fd"]])

export default __exports__